module.exports = __webpack_public_path__ + "static/media/AlertDemo1.e55255f3.jpg";